/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-function-return-type */

import { isAxiosError } from 'axios';
import hwAxios from '../../../rmsReduxStore/api-service/HWAxios';
import { acChargingStationTypes } from '../acReduxExports';

// Charging Station action Creators

const url =  process.env.REACT_APP_SERVER_BASE_URL_AC;

export const fetchAcChargingStationData: any =
	(reqBody: unknown) =>
	async (dispatch: (arg0: Partial<AcChargingStationAction>) => void) => {
		try {
			const loaderStartAction: Partial<AcChargingStationAction> = {
				type: acChargingStationTypes.SET_AC_CHARGING_STATION_LOADER,
				loader: true,
			};
			dispatch(loaderStartAction);
			const response = await hwAxios.post(url + '/charging-stations', reqBody);
			const action: Partial<AcChargingStationAction> = {
				type: acChargingStationTypes.FETCH_AC_CHARGING_STATION_DATA,
				chargingStations: response.data?.data?.chargingStations,
				chargingStationsCount: response.data?.data?.count,
			};
			dispatch(action);
			if (response?.status === 200) {
				const loaderEndAction: Partial<AcChargingStationAction> = {
					type: acChargingStationTypes.SET_AC_CHARGING_STATION_LOADER,
					loader: false,
				};
				dispatch(loaderEndAction);
			}
		} catch (error) {
			const loaderEndAction: Partial<AcChargingStationAction> = {
				type: acChargingStationTypes.SET_AC_CHARGING_STATION_LOADER,
				loader: false,
			};
			dispatch(loaderEndAction);
			console.error(error);
			throw error;
		}
	};

export const exportToCsvAcChargingStationData: any =
	(reqParams: unknown) => async () => {
		try {
			const { data, status } = await hwAxios.post(
				url + '/charging-stations/export',
				reqParams,
			);
			return { data, status };
		} catch (error) {
			if (isAxiosError(error)) {
				if (error.response) {
					const data = error.response.data;
					const status = error.response.status;
					return { data, status };
				}
			} else {
				return {
					data: 'Something went wrong',
					status: 400,
				};
			}
		}
	};

export const setTableListProps: any =
	(data) =>
	async (
		dispatch: (arg0: Partial<AcChargingStationAction>) => void,
	): Promise<void> => {
		const action: Partial<AcChargingStationAction> = {
			type: acChargingStationTypes.SET_AC_CHARGING_STATIONS_TABLE_PROPS,
			chargingStationTableProps: data,
		};
		dispatch(action);
	};

export const fetchIndividualAcStationDetail: any =
	(reqParams: unknown) =>
	async (
		dispatch: (arg0: Partial<AcChargingStationAction>) => void,
	): Promise<void> => {
		try {
			const loaderStartAction: Partial<AcChargingStationAction> = {
				type: acChargingStationTypes.SET_AC_CHARGING_STATION_LOADER,
				loader: true,
			};
			dispatch(loaderStartAction);
			const response = await hwAxios.get(url + '/charging-station', {
				params: reqParams,
			});
			const action: Partial<AcChargingStationAction> = {
				type: acChargingStationTypes.FETCH_AC_SINGLE_STATION_DETAIL,
				singleStationDetail: response?.data?.data?.chargingStation,
			};
			dispatch(action);
			if (response?.status === 200) {
				const loaderEndAction: Partial<AcChargingStationAction> = {
					type: acChargingStationTypes.SET_AC_CHARGING_STATION_LOADER,
					loader: false,
				};
				dispatch(loaderEndAction);
			}
		} catch (error) {
			const loaderEndAction: Partial<AcChargingStationAction> = {
				type: acChargingStationTypes.SET_AC_CHARGING_STATION_LOADER,
				loader: false,
			};
			dispatch(loaderEndAction);
			console.error(error);
			throw error;
		}
	};

export const updateAcChargingStation: any =
	(reqParams: unknown) => async () => {
		try {
			const { data, status } = await hwAxios.put(
				url + '/charging-station',
				reqParams,
			);
			return { data, status };
		} catch (error) {
			if (isAxiosError(error)) {
				if (error.response) {
					const data = error.response.data;
					const status = error.response.status;
					return { data, status };
				}
			} else {
				return {
					data: 'Something went wrong',
					status: 400,
				};
			}
		}
	};



export const createAcChargingStation: any = (reqBody: ICustomerChargingStation) => async () => {
  try {
    const { data, status } = await hwAxios.post(url + '/charging-station', reqBody)
    return { data, status };
  } catch (error) {
    if (isAxiosError(error)) {
      if (error.response) {
        const data = error.response.data;
        const status = error.response.status;
        return { data, status };
      }
    } else {
      return {
        data: 'Something went wrong', status: 400
      }
    }
  }
}